import { render, staticRenderFns } from "./IconTime.vue?vue&type=template&id=f3bc530a&"
import script from "./IconTime.vue?vue&type=script&lang=js&"
export * from "./IconTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports